<template>
  <div class="ChipFilterGroup">
    <ChipFilter
      v-for="option of options"
      :key="option.value"
      :selected="isSelected(option.value)"
      :leftIcon="option.icon"
      :disabled="disabled"
      @click="toggle(option.value)"
      @clear="toggle(option.value)"
    >
      {{ option.label }}
    </ChipFilter>
  </div>
</template>

<script setup lang="ts">
import ChipFilter from '../../atoms/ChipFilter/ChipFilter.vue';
import type { ChipFilterGroupProps } from './ChipFilterGroup.model';

const props = withDefaults(defineProps<ChipFilterGroupProps>(), {
  multiple: false,
  disabled: false,
});

const model = defineModel<string | string[]>({ required: true });

function isSelected(value: string): boolean {
  if (Array.isArray(model.value)) {
    return model.value.includes(value);
  }
  return model.value === value;
}

function toggle(value: string): void {
  if (props.multiple) {
    const current = Array.isArray(model.value) ? model.value : [];
    model.value = current.includes(value)
      ? current.filter((item) => item !== value)
      : [...current, value];
  } else {
    model.value = model.value === value ? '' : value;
  }
}
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;

@layer cvo-ui {
  .ChipFilterGroup {
    display: flex;
    flex-wrap: wrap;
    gap: vars.$dimensions-d-2;
  }
}
</style>
